<template>
  <div class="flex justify-between items-center p-5">
    <div class="flex items-center">
      <d-icon :icon="open ? 'folder-open' : 'folder'" class="text-4xl" />
      <div class="mx-5">
        <p class="font-bold">
          {{ file.name }}
        </p>
        <p class="text-sm" v-html="file.description" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      file: {
        type: Object,
        default: () => ({}),
      },
      open: Boolean,
    },
  };
</script>